import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  BackgroundContainer,
  AbsolutePositioned
} from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import { Panel } from '../../../components/Layout/Panel';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import Logo from '../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../components/Title';
import SocialMedia from '../../../components/SocialMedia';
import Hyperlink from '../../../components/Hyperlink';

// Assets
import { brandColors, device } from '../../../styles/variables';
import background from '../../../assets/images/pages/contact/flower.jpg';
import map from '../../../assets/images/pages/contact/map.jpg';
import map2 from '../../../assets/images/pages/contact/map2.jpg';

const StyledBackgroundContainer = BackgroundContainer.extend``;

const OverlayBackground = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  background: url(${background}) no-repeat;
  background-size: cover;
  background-position: center;
  opacity: 0.4;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitlePosition = styled.div`
  margin: 154px 0 0 0;
`;

const MapImage = styled.div`
  box-shadow: 0 40px 40px 0 rgba(61, 64, 91, 0.41);
  position: absolute;
  left: 42%;
  display: none;
  @media ${device.tablet} {
    top: 216px;
    background: url(${map2});
    background-size: cover;
    height: 540px;
    width: 450px;
    display: block;
  }
  @media ${device.laptop} {
    top: 252px;
    background: url(${map});
    background-size: cover;
    height: 450px;
    width: 540px;
  }
`;

const FeatureScreen = () => (
  <Screen background={brandColors.blue}>
    <OverlayBackground />
    <StyledBackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <Panel top="unset" left="unset" bottom="0" right="0" className="mobileDisplayNone" />
      <MapImage />
    </StyledBackgroundContainer>
    <Logo />
    <ContentContainer>
      <TitlePosition>
        <Title subtitle="contact us" color={brandColors.white}>
          Park <Highlight>life</Highlight>
          <Subtext width="378px" subTextSmall>
            Visit us in our heritage location.<br />The Printworks, 7 Blake Mews, Kew, London, TW9
            3GA{' '}
            <Hyperlink
              linkName="(see on google)"
              linkAddress="https://www.google.co.uk/maps/place/7+Blake+Mews,+Richmond+TW9+3GA"
              constantLink
            />
            <br />
            <br />
            <Title className="Mobile" primary={false}>
              <Hyperlink linkName="020&nbsp;8334&nbsp;7860" linkAddress="tel:02083347860" />
            </Title>
            <SocialMedia />
          </Subtext>
        </Title>
      </TitlePosition>
    </ContentContainer>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/Contact/screens/Feature.jsx